'use strict';

import {routingConfig} from '../../authorizationConfig';

angular.module('FlexyBeautyApp.services')
    .factory('Auth',
        ["$log", "$http", "$window", "$location", "User", "UserSrv", "CustomerSrv", "FirebaseServiceFactory",
            "CookieFactory", "bugsnag", "NotificationSrv", "UserActionManager", "UserData", "OptInOutSrv", "Constants",
            "Brand", "OfferManager", "StoreAppCode",
            function ($log, $http, $window, $location, User, UserSrv, CustomerSrv, FirebaseServiceFactory,
                      CookieFactory, bugsnag, NotificationSrv, UserActionManager, UserData, OptInOutSrv, Constants,
                      Brand, OfferManager, StoreAppCode) {
            // initialisation (refresh page by example)
            let accessLevels;
            let userRoles;
            const CHILD_ADDED_EVENT = "child_added";

                if (routingConfig !== undefined && routingConfig) {
                    accessLevels = routingConfig.accessLevels;
                    userRoles = routingConfig.userRoles;
                }
                let currentUser = null;


            /* For Angular App & React app: setup $window['kiuteProUser'] from backoffice or admin */
            function initKiuteProUser(specialUser, companyCode, isAdminUser) {
                let loggedUser = UserData.getLoggedUser();
                let currencyCode = Constants.DEFAULT_CURRENCY_CODE;
                let localeCode = Constants.DEFAULT_LOCALE_CODE;
                let companyName = '';
                let managerMode = false;
                let serverIdentification = {};
                let clientFullAccess = false;
                let onlineReservationAccess = false;
                let country = 'FR';
                if (loggedUser && loggedUser.company) {
                    if (loggedUser.company.currency) {
                        currencyCode = loggedUser.company.currency.codeMango;
                    }
                    if (loggedUser.company.localeCode) {
                        localeCode = loggedUser.company.localeCode;
                    }
                    companyName = loggedUser.company.name;
                    managerMode = !loggedUser.hasManagerPassword || loggedUser.isManager || isAdminUser;
                    serverIdentification = loggedUser.serverIdentification;
                    clientFullAccess = OfferManager
                        .hasCompanyAccessToFeature(loggedUser.company, StoreAppCode.OPTION_CLIENT_FULL);
                    onlineReservationAccess = OfferManager
                        .hasCompanyAccessToOnlineReservation(loggedUser.company);
                    if (loggedUser.company.country) {
                        country = loggedUser.company.country;
                    }
                }
                const kiuteProUser = Object.assign({
                    currencyCode: currencyCode,
                    companyCode: companyCode,
                    companyName: companyName,
                    localeCode: localeCode,
                    serverIdentification: serverIdentification,
                    managerMode: managerMode,
                    clientFullAccess: clientFullAccess,
                    onlineReservationAccess: onlineReservationAccess,
                    country: country,
                    isAdminUser: isAdminUser,
                }, specialUser);

                $window['kiuteProUser'] = kiuteProUser;

                return kiuteProUser;
            }

            function changeUser(user, companyCode, token, channelId, isProSite, firebaseToken, firebaseEncodedCompanyCode) {
                const absUrl = $location.absUrl();
                if (!absUrl || (absUrl.indexOf(Brand.url.adminUrl) === -1 && absUrl.indexOf(Brand.url.groupUrl) === -1)) {
                    manageUserConnection(absUrl, user, companyCode, token, channelId, firebaseToken, isProSite, firebaseEncodedCompanyCode);
                    $http.defaults.headers.common.Authorization = token;
                } else {
                    currentUser.channelId = channelId;
                    if(isProSite && firebaseToken) {
                        manageFirebaseEvent(companyCode, channelId, firebaseToken, firebaseEncodedCompanyCode);
                    }
                }
                if (absUrl.indexOf(Brand.url.adminUrl) !== -1) {
                    const adminUser = CookieFactory.getCookie('flexyBeauty-admin-user');
                    if (adminUser) {
                        initKiuteProUser(adminUser, companyCode, true);
                    }
                } else if (absUrl.indexOf(Brand.url.groupUrl) !== -1) {
                    const groupUser = CookieFactory.getCookie('flexyBeauty-group-user');
                    if (groupUser) {
                        initKiuteProUser(groupUser, companyCode, true);
                    }
                }
                return currentUser;
            }

            function redirectOnLoginPage() {
                const absUrl = $location.absUrl();
                if (absUrl.indexOf("/connect/") !== -1) {
                    $window.open("/connect", "_self");
                } else {
                    $window.open("/", "_self");
                }
                $location.path('/login');
            }

            function manageUserConnection(absUrl, user, companyCode, token, channelId, firebaseToken, isProSite, firebaseEncodedCompanyCode) {
                if (user) {
                    connectUser(absUrl, user, companyCode, token, channelId, firebaseToken, isProSite, firebaseEncodedCompanyCode);
                } else {
                    disconnectUser(absUrl, isProSite, companyCode);
                }
            }

            function connectUser(absUrl, user, companyCode, token, channelId, firebaseToken, isProSite, firebaseEncodedCompanyCode) {
                currentUser = createCurrentUser(user, token);
                if (isProSite && firebaseToken) {
                    console.info("connectUser - channelId " + channelId);
                    manageFirebaseEvent(companyCode, channelId, firebaseToken, firebaseEncodedCompanyCode);
                }
                createCookie(absUrl, isProSite, user, currentUser, companyCode, channelId);
            }

            function manageFirebaseEvent(companyCode, channelId, firebaseToken, encodedFirebaseCompanyCode) {
                const firebaseService = FirebaseServiceFactory.getFireBaseService();
                if (firebaseService && firebaseToken) {
                    console.info("Firebase : sign-in with channelId " + channelId + " and firebaseToken " + firebaseToken);
                    firebaseService.auth.signInWithCustomToken(firebaseToken)
                        .catch((error) => {
                            console.log("errorCode = " + error.code + ", errorMessage = " + error.message);
                        });
                    firebaseService.auth.onAuthStateChanged((user) => {
                        if (user && user.uid === channelId) {
                            onFirebaseMessageAdded(companyCode, channelId, encodedFirebaseCompanyCode);
                        }
                    });
                }
            }

            function onFirebaseMessageAdded(companyCode, channelId, encodedFirebaseCompanyCode) {
                const nodePath = "company/" + (encodedFirebaseCompanyCode ? encodedFirebaseCompanyCode : companyCode) + "/channel/" + channelId + "/message";
                console.info("Firebase : add observer on " + CHILD_ADDED_EVENT + " for firebase user " + firebaseUserUid() + " on node \"" + nodePath + "\"");
                const firebaseService = FirebaseServiceFactory.getFireBaseService();
                if (firebaseService) {
                    const messageRef = firebaseService.database.ref(nodePath);
                    messageRef.on(CHILD_ADDED_EVENT, (child) => {
                        const message = child.val();
                        console.log("Firebase : new message reception");
                        console.log(message);
                        if (message && message.data && message.sourceChannelId !== channelId
                            && message.targetChannelId === channelId) {
                            console.log("Firebase : new message treated : " + JSON.stringify(message));
                            const userAction = JSON.parse(message.data);
                            if (userAction && userAction.objectType === "Notification") {
                                NotificationSrv.onNotificationChannel(userAction);
                            } else {
                                UserActionManager.executeUserAction(userAction, true);
                            }
                        } else if (message && message.sourceChannelId === channelId) {
                            console.log("Firebase : new message not treated because modificatiion message was emitted by the current channelId");
                        } else if (message && message.targetChannelId !== channelId) {
                            console.log("Firebase : new message not treated because current channelId (" + channelId + ") not in targetted (targetChannelId : " + message.targetChannelId + ")");
                        } else {
                            console.log("Firebase : new message not treated");
                        }
                    });
                }
            }

            function firebaseUserUid() {
                let userUid = "/Not connected to firebase/";
                const firebaseService = FirebaseServiceFactory.getFireBaseService();
                if (firebaseService) {
                    userUid = (firebaseService.auth && firebaseService.auth.currentUser) ? firebaseService.auth.currentUser.uid : userUid;
                }
                return userUid;
            }

            function disconnectUser(absUrl, isProSite, companyCode) {
                currentUser = deleteCurrentUser();
                deleteCookie(absUrl, isProSite, companyCode);
            }

            function createCurrentUser(user, token) {
                return {
                    id: user.id,
                    email: user.email,
                    phone: user.phone,
                    role: user.role,
                    companyCode: user.companyCode,
                    companyName: user.companyName,
                    token: token //token for rest security
                };
            }

            function deleteCurrentUser() {
                return {
                    id: null,
                    email: '',
                    phone: '',
                    role: userRoles.public,
                    companyCode: null,
                    companyName: null,
                    token: null
                }
            }

            function createCookie(absUrl, isProSite, user, cookieUser, companyCode, channelId) {
                const kiuteProUser = initKiuteProUser(cookieUser, companyCode, false);
                const currentUserCookie = Object.assign(kiuteProUser, {
                    channelId: channelId,
                });

                if (absUrl.indexOf("/connect#") !== -1 && isProSite) {
                    CookieFactory.setCookieRoot('flexyBeauty-connect-user-' + user.companyCode, currentUserCookie);
                } else {
                    if (isProSite) {
                        CookieFactory.setCookie('flexyBeauty-pro-user', currentUserCookie);
                    } else {
                        CookieFactory.setCookie('flexyBeauty-web-user-' + companyCode, currentUserCookie);
                        bugsnag.user = {
                            id: companyCode,
                            email: user.email
                        };
                    }
                }
            }

            function deleteCookie(absUrl, isProSite, companyCode) {
                if (absUrl.indexOf("/connect/") !== -1 && isProSite) {
                    const index = absUrl.indexOf("connect/");
                    let connectCompanyCode = absUrl.substr(index + 8);
                    const index2 = connectCompanyCode.indexOf("#");
                    if (index2 !== -1) {
                        connectCompanyCode = connectCompanyCode.substr(0, index2);
                    }
                    CookieFactory.removeCookieRoot('flexyBeauty-connect-user-' + connectCompanyCode);
                } else {
                    if (isProSite) {
                        CookieFactory.removeCookie('flexyBeauty-pro-user');
                    } else {
                        CookieFactory.removeCookie('flexyBeauty-web-user-' + companyCode);
                        bugsnag.user = {
                            id: companyCode,
                            email: ""
                        };
                    }
                }
            }

            function afterLogout(companyCode, success, successParam) {
                changeUser(null, companyCode, null, null, true);
                if (success !== undefined) {
                    success(successParam);
                }
                redirectOnLoginPage();
            }

            function isAdmin(absUrl) {
                return absUrl && absUrl.indexOf(Brand.url.adminUrl) !== -1;
            }

            function isGroup(absUrl) {
                return absUrl && absUrl.indexOf(Brand.url.groupUrl) !== -1;
            }

            return {
                init: function (isProSite, companyCode) {
                    const absUrl = $location.absUrl();
                    if (isAdmin(absUrl)) {
                        //Admin mode
                        const adminUrlPattern = Brand.url.adminUrl;
                        const index = absUrl.indexOf(adminUrlPattern);
                        let currentCompanyCode = absUrl.substr(index + adminUrlPattern.length);
                        const index2 = currentCompanyCode.indexOf("#");
                        if (index2 !== -1) {
                            currentCompanyCode = currentCompanyCode.substr(0, index2);
                        }
                        currentUser = CookieFactory.getCookie('flexyBeauty-admin-user');
                        if (currentUser) {
                            currentUser.companyCode = currentCompanyCode;
                            currentUser.role = userRoles.admin;
                            $http.defaults.headers.common.Authorization = currentUser.token + '&' + currentCompanyCode;
                        }
                    } else if (isGroup(absUrl)) {
                        const groupUrlPattern = Brand.url.groupUrl;
                        const index = absUrl.indexOf(groupUrlPattern);
                        let currentCompanyCode = absUrl.substr(index + groupUrlPattern.length);
                        const index2 = currentCompanyCode.indexOf("#");
                        if (index2 !== -1) {
                            currentCompanyCode = currentCompanyCode.substr(0, index2);
                        }
                        currentUser = CookieFactory.getCookie('flexyBeauty-group-user');
                        if (currentUser) {
                            currentUser.companyCode = currentCompanyCode;
                            currentUser.role = userRoles.admin;
                            $http.defaults.headers.common.Authorization = currentUser.token + '&' + currentCompanyCode;
                        }
                    } else if (absUrl && (absUrl.indexOf("/connect", absUrl.length - 8) !== -1)
                        || absUrl.indexOf("/connect/") !== -1
                        || absUrl.indexOf("/connect#") !== -1) {
                        //Multi mode
                        const index = absUrl.indexOf("connect/");
                        if (index !== -1) {
                            let currentCompanyCode = absUrl.substr(index + 8);
                            const index2 = currentCompanyCode.indexOf("#");
                            if (index2 !== -1) {
                                currentCompanyCode = currentCompanyCode.substr(0, index2);
                            }
                            currentUser = CookieFactory.getCookie('flexyBeauty-connect-user-' + currentCompanyCode);
                            if (currentUser) {
                                $http.defaults.headers.common.Authorization = currentUser.token;
                            }
                        }
                    } else if (!currentUser) {
                        if (isProSite) { // connection to connect site
                            currentUser = CookieFactory.getCookie('flexyBeauty-pro-user');
                        } else { // connection to web site
                            currentUser = CookieFactory.getCookie('flexyBeauty-web-user-' + companyCode);
                            if (!currentUser) { //for old compatibility
                                currentUser = CookieFactory.getCookie('flexyBeauty-web-user');
                                CookieFactory.setCookie('flexyBeauty-web-user-' + companyCode, currentUser);
                                CookieFactory.removeCookie('flexyBeauty-web-user');
                            }
                        }
                        if (currentUser) {
                            $http.defaults.headers.common.Authorization = currentUser.token;
                        }
                    }
                },
                authorize: function (accessLevel, role) {
                    if (role === undefined && currentUser) {
                        role = currentUser.role;
                    } else {
                        role = userRoles.public;
                    }
                    if (accessLevel) {
                        return accessLevel.bitMask & role.bitMask;
                    } else {
                        return null;
                    }
                },
                isAdmin: function () {
                    if (currentUser) {
                        return currentUser.role === userRoles.admin;
                    }
                },
                isAdminNotGroup: function () {
                    return isAdmin($location.absUrl()) && !isGroup($location.absUrl())
                },
                isLoggedIn: function (user) {
                    if (user === undefined) {
                        user = currentUser;
                    }
                    if (user) {
                        return user.role.title === userRoles.user.title
                            || user.role.title === userRoles.admin.title;
                    } else {
                        return false;
                    }
                },
                clearWebSiteUser: function (companyCode) {
                    changeUser(null, companyCode, null, false);
                },
                getCompanyCode: function () {
                    if (currentUser) {
                        return currentUser.companyCode;
                    }
                    return '';
                },
                getCompanyName: function () {
                    if (currentUser) {
                        return currentUser.companyName;
                    }
                    return '';
                },
                getCurrentUser: function () {
                    return currentUser;
                },
                getToken: function () {
                    if (currentUser) {
                        return currentUser.token;
                    }
                    return '';
                },
                registerToProSite: function (user, success, error) {
                    UserSrv.register(user, function (res) {
                        changeUser(user, user.companyCode, res.token, res.channelId, true);
                        if (success !== undefined) {
                            success(res);
                        }
                    }, error);
                },
                loginToProSite: function (user, success, error) {
                    UserSrv.login(user, function (res) {
                        $http.defaults.headers.common.Authorization = res.token;
                        currentUser = createCurrentUser(user, res.token);
                        createCookie($location.absUrl(), true, user, currentUser, user.companyCode);
                        if (success !== undefined) {
                            success(res);
                        }
                    }, error);
                },
                loginToProSiteOnForgetPwd: function (user, token, success, error) {
                    UserSrv.loginOnForgetPwd(user, token, function (res) {
                        changeUser(user, user.companyCode, res.token, res.channelId, true);
                        if (success !== undefined) {
                            success(res);
                        }
                    }, error);
                },
                loginToWebSite: function (companyCode, customer, success, error) {
                    if (customer) {
                        CustomerSrv.login(customer, function (res) {
                            changeUser(customer, companyCode, res.token, null, false);
                            if (success !== undefined) {
                                success(customer);
                            }
                        }, error);
                    } else {
                        UserSrv.loginAnonymous(companyCode, function (res) {
                            // Set token in memory but store no cookies
                            changeUser(null, companyCode, res.token, null, false);
                            if (success !== undefined) {
                                success(customer);
                            }
                        }, error);
                    }
                },
                loginToWebSiteByToken: function (email, companyCode, token) {
                    changeUser({email: email}, companyCode, token, null, false);
                },
                createChannel: function (user) {
                    return UserSrv.createChannel()
                        .then((data) => {
                            $http.defaults.headers.common["Channel-Id"] = data.channelId;
                            sessionStorage.setItem('channelId', data.channelId);
                            return changeUser(user, user.companyCode, user.token, data.channelId, true, data.firebaseToken, data.firebaseEncodedCompanyCode);
                        })
                        .catch(); // This empty catch is used to throw an exception to the calling method
                },
                changeUserFromWebSite: function (customer, companyCode, token) {
                    changeUser(customer, companyCode, token, null, false);
                },
                registerToWebSite: function (customer, companyCode, success, error) {
                    CustomerSrv.register(customer, function (res) {
                        changeUser(customer, companyCode, res.token, null, false);
                        customer.optInOut.customerId = res.userId;
                        OptInOutSrv.save(customer.optInOut, function () {
                                if (success !== undefined) {
                                    success(customer);
                                }
                            },
                            error);
                    }, error);
                },
                logout: function (success, error) {
                    const absUrl = $location.absUrl();
                    if (currentUser && (!absUrl ||
                        (absUrl.indexOf(Brand.url.adminUrl) === -1 && absUrl.indexOf(Brand.url.groupUrl) === -1))) {
                        const user = new User(currentUser);
                        UserSrv.logout(user,
                            function (res) {
                                afterLogout(user.companyCode, success, res);
                            }, function (res) {
                                //Force logout and clear token of cookie
                                changeUser(null, user.companyCode, null, null, true);
                                if (error !== undefined) {
                                    error(res);
                                }
                                redirectOnLoginPage();
                            });
                    }
                },
                logoutFromWeb: function (customer, companyCode, success, error) {
                    if (currentUser) {
                        if (customer) {
                            CustomerSrv.logout(customer,
                                function (res) {
                                    changeUser(null, companyCode, null, null, false);
                                    if (success !== undefined) {
                                        success(res);
                                    }
                                }, function (res) {
                                    //Force logout and clear token of cookie
                                    changeUser(null, companyCode, null, null, false);
                                    if (error !== undefined) {
                                        error(res);
                                    }
                                });
                        } else {
                            changeUser(null, currentUser.companyCode, null, null, false);
                            if (success !== undefined) {
                                success();
                            }
                        }
                    }
                },
                afterLogout: afterLogout,
                accessLevels: accessLevels,
                userRoles: userRoles,
                user: currentUser
            };
        }]);



// WEBPACK FOOTER //
// ./js/services/permissions/Auth.js